<style lang="scss" scoped>
@import "../../../assets/scss/mixins";

$border-color: #eee;
.bg-white {
  margin-bottom: 20px;
  padding: 15px;
  background: #fff;
}

.main-info-dom {
  font-size: 14px;
}

.oms-row {
  margin-bottom: 7px;
}

.list-flex {
  display: flex;
  /*justify-content: space-between;*/
  .list-box {
    font-size: 12px;
    width: 32%;
    margin-right: 1.2%;
    background: #eee;

    .body {
      padding: 10px 15px;

      .oms-row {
        margin-bottom: 7px;
        align-items: center;
      }

      .label {
        color: $info-color;
        margin: 5px 0;
      }
    }

    h3 {
      font-size: 14px;
      margin: 0;
      padding: 10px;
      background: $error-color;
      color: #fff;
      display: flex;
      align-items: center;
      font-weight: normal;

      i {
        margin-right: 7px;
        font-size: 24px;
      }
    }

    &:nth-child(2) {
      h3 {
        background: $warning-color
      }
    }

    &:nth-child(3) {
      h3 {
        background: $success-color
      }
    }

    &:nth-child(4) {
      h3 {
        background: $selected-color
      }
    }

    h4 {
      margin: 0;
      padding: 7px 0 7px 4px;
    }
  }
}

.list_log {
  .list_item {
    clear: both;

    .ml5 {
      margin-left: 5px;
    }
  }
}

.color_date {
  color: #999;
}

.search-row {
  align-items: center;

  > div {
    white-space: nowrap;
  }
}

h2 {
  padding: 0;
  font-size: 18px;
  line-height: 24px;
  border-left: 5px solid $error-color;
  position: relative;
  margin: 0 0 10px;

  > span:first-child {
    position: relative;
    z-index: 3;
    background: #fff;
    padding: 0 12px;
  }
}

.flow-double-bar {
  width: 100%;
  padding: 0;
  display: table;
  border-top: 20px solid #f9f9f9;
  /*border-bottom: 20px solid #f9f9f9;*/
  > div {
    overflow: auto;
    display: table-cell;

    &:first-child {
      /*background: #fff;*/
      width: 500px;
      text-align: center;

      .info-item {
        margin: 10px 10px;
        padding: 5px;
        line-height: 22px;
        cursor: pointer;
        border-radius: 4px;
        border: 1px solid $border-color;

        &.error {
          color: $error-color;
          border-color: $error-color;
        }

        /*&:hover {*/
        /*background: #f1f1f1*/
        /*}*/
        .time {
          font-size: 12px;
        }
      }

      h3 {
        font-size: 14px;
        padding: 0;
        margin: 0;
      }
    }

    &:last-child {
      width: calc(100% - 500px);
      background: #fff;
      border-left: 15px solid #f9f9f9;

      &.info-item {
        padding: 15px;
        margin: 0 0 0 15px;
        background: #eee0;

        h3 {
          margin: 0;
          padding: 0;
          border-left: 5px solid $error-color;

          > span {
            padding-left: 12px;
          }
        }

        &.open {
          background: #fff;
          /*margin: 5px;*/
          border-radius: 0;
        }

        .oms-row {
          margin-bottom: 8px;
        }
      }
    }
  }
}

.no-rights-tooltip {
  text-align: center;
  font-size: 16px;
}

.title {
  margin: 0 0 10px 0;
  padding-left: 10px;
}
</style>
<style lang="scss">
@import "../../../assets/scss/mixins";

.timeLine__code {
  margin-left: 80px;
  margin-top: 20px;

  .tiny-timeline-item-left {
    position: absolute;
    left: 15px;
    top: 4px;
    transform: translateY(-50%);
  }

  .tiny-timeline-item-head-custom {
    min-width: 32px;
    min-height: 32px;
    text-align: center;
    line-height: 1;
    border-radius: 50%;
    font-size: 16px;
    position: absolute;
    left: 143px;
    transform: translateY(-50%);
    cursor: pointer;

    i.iconfont {
      line-height: 30px;
      font-size: 24px;
      color: #333;

      &.active {
        color: $error-color;
      }

      &.el-icon-error {
        margin-top: 1px;
      }
    }
  }

  .tiny-timeline-item-end {
    height: 33px;

    .tiny-timeline-item-end-custom {
      border-radius: 0;
      background-color: transparent;
      text-align: center;
      position: absolute;
      left: 142px;
      transform: translateY(-50%);

      .el-icon-caret-bottom {
        line-height: 32px;
        font-size: 28px;

        &.active {
          color: $error-color;
        }
      }
    }
  }

  .tiny-timeline-item-head-default {
    border-color: #333;
    color: #333;

    &.active {
      border-color: $error-color;
      color: $error-color;
    }
  }

  .tiny-timeline-item-tail {
    height: 100%;
    border-left: 2px solid #333;
    position: absolute;
    left: 159px;
    top: 0;

    .tiny-timeline--arrow {
      position: absolute;
      bottom: 14px;
      left: 50%;
      transform: translateX(-9px);
      font-size: 16px;
    }
  }

  .tiny-timeline-item-content {
    padding-left: 20px;
    text-align: left;
    left: 170px;
    width: 150px;
    top: -8px;
    cursor: pointer;

    .title {
      font-size: 16px;
      font-weight: bold;

      &.active {
        color: $activeColor;
      }
    }
  }

  .tiny-timeline-item {
    padding: 0 0 30px 0;
  }
}

.el-collapse--code {
  .el-collapse-item__header {
    padding-left: 10px;
  }

  .el-collapse-item__content {
    padding-bottom: 0;
  }
}
</style>
<template>
  <div class="order-page">
    <div class="container">
      <div :class="{up:!showSearch}" class="opera-btn-group">
        <div class="opera-icon">
          <span class="pull-right opera-btn" style="margin-left: 10px">
          </span>
          <span class="pull-left switching-icon" @click="showSearch = !showSearch">
              <i class="el-icon-arrow-up"></i>
              <span v-show="showSearch">收起筛选</span>
              <span v-show="!showSearch">展开筛选</span>
            </span>
        </div>
        <el-form v-show="showSearch" class="advanced-query-form" onsubmit="return false">
          <el-row>
            <el-col :span="12">
              <oms-form-row label="父级追溯码" :span="6">
                <oms-input type="text" v-model="searchCondition.code" placeholder="请输入追溯码查询"></oms-input>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row :span="5" label="">
                <el-button @click="searchInOrder" plain type="primary">查询</el-button>
                <el-button @click="resetSearchForm" native-type="reset">重置</el-button>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <template v-if="baseInfo.code">
        <div>
          <div class="bg-white">
            <h2>
              <span>父级追溯码信息</span>
              <el-tag
                :type="formatStatus(baseInfo).isDanger ? 'danger' : baseInfo.status === '0' ? 'warning' : 'success'">
                {{ formatStatus(baseInfo).title }}
              </el-tag>
            </h2>
            <el-row :gutter="12" class="main-info-dom">
              <el-col :span="12">
                <oms-row label="追溯码" :span="labelSpan" class="R">{{ baseInfo.code }}</oms-row>
                <oms-row label="品名" :span="labelSpan" v-show="baseInfo.goodsName">
                  <el-tooltip :content="'DHS-ID: '+baseInfo.goodsId" placement="right">
                    <span> {{ baseInfo.goodsName }}</span>
                  </el-tooltip>
                </oms-row>
                <oms-row label="制剂规格" :span="labelSpan" v-show="baseInfo.specification">{{
                    baseInfo.specification
                  }}
                </oms-row>
                <oms-row label="生产企业" :span="labelSpan" v-show="baseInfo.factoryName ">{{
                    baseInfo.factoryName
                  }}
                </oms-row>
                <oms-row label="质量状态" :span="labelSpan" v-show="baseInfo.qualifiedFlag!==null&&!baseInfo.qualifiedFlag">
                  <el-tag type="success" v-if="baseInfo.qualifiedFlag">合格</el-tag>
                  <el-tag type="primary" v-if="!baseInfo.qualifiedFlag">不合格</el-tag>
                </oms-row>
                <oms-row label="上市许可持有人" :span="labelSpan" v-show="baseInfo.expirationDate">
                  {{ baseInfo.vaccineMarketingApprovalPossessorName }}
                </oms-row>
                <oms-row label="包装层级" :span="labelSpan" v-show="baseInfo.packageScheme">{{
                    packageType[baseInfo.packageScheme
                    - 1]
                  }}
                </oms-row>
              </el-col>
              <el-col :span="12">
                <oms-row class="R" label="批号" :span="labelSpan" v-show="baseInfo.batchNumber">{{ baseInfo.batchNumber }}
                </oms-row>
                <oms-row class="R" label="包装规格" :span="labelSpan" v-show="baseInfo.packingSpecification">
                  {{ baseInfo.packingSpecification }}
                </oms-row>
                <oms-row class="R" label="剂型" :span="labelSpan" v-show="baseInfo.dosageForm">
                  <dict :dict-group="'dosageForm'" :dict-key="baseInfo.dosageForm"></dict>
                </oms-row>
                <oms-row label="生产日期" :span="labelSpan" v-show="baseInfo.productionDate">
                  {{ baseInfo.productionDate | date }}
                </oms-row>
                <oms-row label="有效期至" :span="labelSpan" v-show="baseInfo.expirationDate">
                  {{ baseInfo.expirationDate | date }}
                </oms-row>
                <oms-row label="通关单号" :span="labelSpan" v-show="baseInfo.customsFormNumber">
                  {{ baseInfo.customsFormNumber }}
                  <el-tag type="success" v-if="baseInfo.qualifiedFlag">已通关</el-tag>
                </oms-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </template>
      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="1">序号</el-col>
          <el-col :span="4">子追溯码</el-col>
          <el-col :span="4">货品</el-col>
          <el-col :span="3">货品编号</el-col>
          <el-col :span="6">规格</el-col>
          <el-col :span="3">批号</el-col>
          <el-col :span="3">层级</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="!orderList.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div class="order-list-body flex-list-dom" v-else="">
          <div :class="[{'active':currentId===item.id}]"
               class="order-list-item order-list-item-bg"
               v-for="(item,index) in orderList">
            <el-row>
              <el-col :span="1">
                {{ index + 1 }}
              </el-col>
              <el-col :span="4">
                {{ item.code }}
              </el-col>
              <el-col :span="4">
                {{ item.goodsName }}
              </el-col>
              <el-col :span="3">
                {{ item.goodsCode }}
              </el-col>
              <el-col :span="6">
                {{ item.specification }}
              </el-col>
              <el-col :span="3">
                {{ item.batchNumber }}
              </el-col>
              <el-col :span="3">
                {{ filterPackageScheme(item.packageScheme) }}
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {http} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';
import utils from "@/tools/utils";

export default {
  components: {},
  mixins: [methodsMixin],
  data: function () {
    return {
      labelSpan: 5,
      boxLabelSpan: 6,
      loadingData: false,
      showSearch: true,
      orderList: [],
      packageType: utils.packageType,
      filters: {
        code: ''
      },
      searchCondition: {
        code: ''
      },
      currentId: '',
      currentItem: {},
      baseInfo: {},
      statusType: ['未知', '流转中', '已使用', '异常', '已报损', '注销']
    };
  },
  computed: {
    type() {
      return this.$route.meta.type;
    },
    isUploadPage() {
      return this.type === 1;
    }
  },
  mounted() {
  },
  watch: {
    type() {
      this.getOrderList();
    }
  },
  methods: {
    formatStatus(baseInfo) {
      let obj = {
        title: this.statusType[baseInfo.status],
        isDanger: false
      };
      if (baseInfo.status === '3') obj.isDanger = true;
      if (baseInfo.status === '1' && this.$moment(baseInfo.expirationDate).diff(this.$moment(this.$moment().format('YYYY-MM-DD'))) < 0) {
        obj.title = '已过期';
        obj.isDanger = true;
      }
      return obj;
    },
    filterPackageScheme(val) {
      if (!val) return;
      return "第" + val + "层级";
    },
    searchInOrder: function () {// 搜索
      if (!this.searchCondition.code) {
        return this.$notify.info(`请输入父级追溯码`);
      }
      this.getOrderList();
    },
    resetSearchForm: function () {// 重置表单
      this.orderList = [];
      this.baseInfo = {};
      let temp = {
        code: ''
      };
      Object.assign(this.searchCondition, temp);
      Object.assign(this.filters, temp);
    },
    getOrderList: function () {
      let param = {};
      this.loadingData = true;
      let params = {
        code: this.searchCondition.code,
      }
      http.get('/code/children-code', {params}).then(res => {
        this.baseInfo = res.data;
        this.orderList = this.baseInfo.childrenCodeList;
        this.loadingData = false;
      }).catch(error => {
        this.$notify.error({
          message: error.response.data && error.response.data.msg || '查询追溯码子码失败'
        });
        this.orderList = [];
        this.baseInfo = {};
        this.loadingData = false;
      });
    }
  }
};
</script>
